/**
 * 定数記録用ファイル
 */
// tslint:disable-next-line:no-namespace
export namespace AuthoritiesId {

  /** 権限情報頭文字 */
  export const ROLE: string = 'ROLE_';

  /** 管理者権限 */
  export const ROLE_CYDEEN2_ADMIN: string = 'ROLE_CYDEEN2_ADMIN';

  /** 発注者権限 新規 */
  export const ORD_CREATE: string = ROLE + 'UKETSUKE_ORD_CREATE';
  /** 発注者権限 参照 */
  export const ORD_READ: string = ROLE + 'UKETSUKE_ORD_READ';
  /** 発注者権限 更新 */
  export const ORD_UPDATE: string = ROLE + 'UKETSUKE_ORD_UPDATE';
  /** 発注者権限 削除 */
  export const ORD_DELETE: string = ROLE + 'UKETSUKE_ORD_DELETE';

  /** 申請権限 新規 */
  export const APP_CREATE: string = ROLE + 'UKETSUKE_APP_CREATE';
  /** 申請権限 参照 */
  export const APP_READ: string = ROLE + 'UKETSUKE_APP_READ';
  /** 申請権限 更新 */
  export const APP_UPDATE: string = ROLE + 'UKETSUKE_APP_UPDATE';
  /** 申請権限 削除 */
  export const APP_DELETE: string = ROLE + 'UKETSUKE_APP_DELETE';

  /** CE財団権限 新規 */
  export const CEF_CREATE: string = ROLE + 'UKETSUKE_CEF_CREATE';
  /** CE財団権限 参照 */
  export const CEF_READ: string = ROLE + 'UKETSUKE_CEF_READ';
  /** CE財団権限 更新 */
  export const CEF_UPDATE: string = ROLE + 'UKETSUKE_CEF_UPDATE';
  /** CE財団権限 削除 */
  export const CEF_DELETE: string = ROLE + 'UKETSUKE_CEF_DELETE';

  /** マスタ権限 新規 */
  export const MST_CREATE: string = ROLE + 'KANRI_MST_CREATE';
  /** マスタ権限 参照 */
  export const MST_READ: string = ROLE + 'KANRI_MST_READ';
  /** マスタ権限 更新 */
  export const MST_UPDATE: string = ROLE + 'KANRI_MST_UPDATE';
  /** マスタ権限 削除 */
  export const MST_DELETE: string = ROLE + 'KANRI_MST_DELETE';

  /** メールスケジュール権限 新規 */
  export const MSS_CREATE: string = ROLE + 'KANRI_MSS_CREATE';
  /** メールスケジュール権限 参照 */
  export const MSS_READ: string = ROLE + 'KANRI_MSS_READ';
  /** メールスケジュール権限 更新 */
  export const MSS_UPDATE: string = ROLE + 'KANRI_MSS_UPDATE';
  /** メールスケジュール権限 削除 */
  export const MSS_DELETE: string = ROLE + 'KANRI_MSS_DELETE';

  /** 組織情報権限 新規 */
  export const ORG_CREATE: string = ROLE + 'KANRI_ORG_CREATE';
  /** 組織情報権限 参照 */
  export const ORG_READ: string = ROLE + 'KANRI_ORG_READ';
  /** 組織情報権限 更新 */
  export const ORG_UPDATE: string = ROLE + 'KANRI_ORG_UPDATE';
  /** 組織情報権限 削除 */
  export const ORG_DELETE: string = ROLE + 'KANRI_ORG_DELETE';

  /** ユーザ情報権限 新規 */
  export const USR_CREATE: string = ROLE + 'KANRI_USR_CREATE';
  /** ユーザ情報権限 参照 */
  export const USR_READ: string = ROLE + 'KANRI_USR_READ';
  /** ユーザ情報権限 更新 */
  export const USR_UPDATE: string = ROLE + 'KANRI_USR_UPDATE';
  /** ユーザ情報権限 削除 */
  export const USR_DELETE: string = ROLE + 'KANRI_USR_DELETE';

  /** EUC権限 新規 */
  export const EUC_CREATE: string = ROLE + 'KANRI_EUC_CREATE';
  /** EUC権限 参照 */
  export const EUC_READ: string = ROLE + 'KANRI_EUC_READ';
  /** EUC権限 更新 */
  export const EUC_UPDATE: string = ROLE + 'KANRI_EUC_UPDATE';
  /** EUC権限 削除 */
  export const EUC_DELETE: string = ROLE + 'KANRI_EUC_DELETE';

}

